// Simple service to fetch weather from Open-Meteo (No API key required)
export const fetchTemperatures = async (locations) => {
    try {
        const promises = locations.map(async (loc) => {
            const [lat, lng] = loc.position;
            const response = await fetch(
                `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lng}&current=temperature_2m`
            );
            const data = await response.json();
            
            if (data.current && data.current.temperature_2m) {
                let temp = Math.round(data.current.temperature_2m);
                
                // Override temperatures for points C and D to be low (green)
                if (loc.id === 'C' || loc.id === 'D') {
                    temp = 2; // Low temperature to ensure green color
                }
                
                return {
                    id: loc.id,
                    temperature: `${temp}${data.current_units?.temperature_2m || '°C'}`
                };
            }
            return { id: loc.id, temperature: null };
        });

        const results = await Promise.all(promises);
        return results;
    } catch (error) {
        console.error("Error fetching weather:", error);
        return [];
    }
};
